import axios from "axios";
import { format } from "date-fns";
import { toast } from "react-toastify";

import { TicketTimeTracking } from "./TicketTimeTracking";
import { getTotalTimeInHoursAndMinutes } from "../../common/utils/dateHelper";

const TICKET_TIME_TRACKING_API_URL = `${process.env.REACT_APP_API_BASE_URL}/tickets/time-tracking`;

export const fetchTicketTimeTracking = async (ticketId: string) => {
  try {
    const response = await axios.get(`${TICKET_TIME_TRACKING_API_URL}/${ticketId}`);
    const ticketTimeTrackings: TicketTimeTracking[] = response.data.map(mapApiTicketTimeTracking);
    return ticketTimeTrackings;
  } catch (err) {
    return [];
  }
};

export const createTicketTimeTracking = async (ticketId: string, timeTracking: TicketTimeTracking) => {
  const payload = mapTicketTimeTrackingToApi(ticketId, timeTracking);
  await axios.post(`${TICKET_TIME_TRACKING_API_URL}`, payload);
  toast.success("Activitate adaugata cu succes!");
};

export const deleteTicketTimeTracking = async (timeTrackingId: string) => {
  await axios.delete(`${TICKET_TIME_TRACKING_API_URL}/${timeTrackingId}`);
  toast.success("Activitatea a fost stearsa cu succes!");
};

const mapApiTicketTimeTracking = (apiTicketTimeTracking: any): TicketTimeTracking => {
  const start = new Date(`${apiTicketTimeTracking.startTime}Z`);
  const end = new Date(`${apiTicketTimeTracking.endTime}Z`);
  const totalTime = getTotalTimeInHoursAndMinutes(start, end);

  return {
    id: `${apiTicketTimeTracking.id}`,
    ticketId: apiTicketTimeTracking.ticketId,
    userId: apiTicketTimeTracking.userId,
    userName: `${apiTicketTimeTracking.user.firstName} ${apiTicketTimeTracking.user.lastName}`,
    date: format(new Date(`${apiTicketTimeTracking.date}Z`), "dd/MM/yyyy"),
    startTime: format(start, "HH:mm"),
    endTime: format(end, "HH:mm"),
    totalTime,
    isBillable: apiTicketTimeTracking.isBillable,
    description: apiTicketTimeTracking.description,
  };
};

const mapTicketTimeTrackingToApi = (ticketId: string, tracking: TicketTimeTracking) => ({
  ticketId: parseInt(ticketId),
  date: new Date(tracking.date).toISOString(),
  startTime: new Date(tracking.startTime).toISOString(),
  endTime: new Date(tracking.endTime).toISOString(),
  isBillable: tracking.isBillable,
  description: tracking.description,
});
